var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Thumb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1372 21H17.0415C17.6782 21 18.2229 20.6164 18.4531 20.0641L20.7699 14.6557C20.8389 14.4792 20.8773 14.2951 20.8773 14.0957V12.5614C20.8773 11.7175 20.1868 11.0271 19.343 11.0271H14.5023L15.231 7.52121L15.2541 7.27572C15.2541 6.96119 15.1236 6.66968 14.9165 6.46255L14.1033 5.65704L9.04783 10.7125C8.77166 10.9887 8.60289 11.3723 8.60289 11.7942V19.4657C8.60289 20.3096 9.29332 21 10.1372 21ZM10.1372 11.7942L13.4666 8.4648L12.4386 12.5614H19.343V14.0957L17.0415 19.4657H10.1372V11.7942ZM4 11.7942H7.06859V21H4V11.7942Z",
    fill: "#F6B52D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7399 0.287018H13.2056V4.12276H14.7399V0.287018ZM21 3.55507L19.9183 2.47339L17.1873 5.19676L18.2689 6.27844C18.2689 6.27844 20.9156 3.57808 21 3.55507ZM10.7588 5.19677L9.67709 6.27845C9.67709 6.27845 7.03043 3.57809 6.94604 3.55508L8.03539 2.46573L10.7588 5.19677Z",
    fill: "#F6B52D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.5a07f66e9b0a7e37b78d5d74f5519895.svg";
export { ForwardRef as ReactComponent };